"use client";

import type { ReactNode } from "react";
import type { SpaceBackgroundVariant } from "@/game/backgrounds/SpaceMenuBackgroundScene";
import { SpaceMenuBackground } from "./SpaceMenuBackground";

interface MenuScreenShellProps {
  children: ReactNode;
  variant?: SpaceBackgroundVariant;
  className?: string;
}

export function MenuScreenShell({
  children,
  variant = "home",
  className = "",
}: MenuScreenShellProps) {
  return (
    <div className={`relative flex h-full min-h-0 flex-1 flex-col overflow-hidden ${className}`}>
      <SpaceMenuBackground variant={variant} />
      <div className="relative z-10 flex min-h-0 flex-1 flex-col">{children}</div>
    </div>
  );
}
